import { render, staticRenderFns } from "./headphone.vue?vue&type=template&id=58bac41e&"
import script from "./headphone.vue?vue&type=script&lang=js&"
export * from "./headphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports